import {Suspense, useEffect, useState} from "react";
import {Provider, useDispatch, useSelector} from "react-redux";
import {useRoutes} from "react-router";
import routes, {authPages} from "./routes";
import Drawer from "../../publicComponent/Drawer";
import store from "../../reducer/store";
import LoginForm from "../../publicComponent/LoginForm";
import {setDrawerLogin, setDrawerRegister, setDrawerSearch, setDrawerForgetPwd} from "../../reducer/actions";
import {mediaMatch} from "../../utils";
import {useLocation} from "react-router";
import cookies from "../../utils/cookies";
import {useNavigate} from "react-router";
import {useNavigateTo} from "../../hooks/useNavigateTo";
import RegisterForm from "../../publicComponent/RegisterForm";
import ForgetPwdForm from "../../publicComponent/ForgetPwdForm";
import {useTranslation} from "react-i18next";
import WhatsAppButton from "../../publicComponent/WhatsAppButton";
import {ga} from '../../utils/ga';
import '../../css/public.css';
import '../../css/swiper.css';
import '../mall9.css';

function LoginDrawer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { drawerLogin } = useSelector(state => state);
  
  return (
    <Drawer visible={drawerLogin}
            onClose={() => dispatch(setDrawerLogin(false))}>
      <div className={'px-[8%] mt-[22%]'}>
        <h3 className={'text-2xl mb-[80px]'}>
          <i className={'iconfont icon-delete text-2xl mr-[20px] cursor-pointer'}
             onClick={() => dispatch(setDrawerLogin(false))}></i>
          {t('登录')}
        </h3>
        <LoginForm/>
      </div>
    </Drawer>
  );
}

function RegsiterDrawer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { drawerRegister } = useSelector(state => state);
  
  return (
    <Drawer visible={drawerRegister}
            onClose={() => dispatch(setDrawerRegister(false))}>
      <div className={'px-[8%] mt-[22%]'}>
        <h3 className={'text-2xl mb-[50px]'}>
          <i className={'iconfont icon-delete text-2xl mr-[20px] cursor-pointer'}
             onClick={() => dispatch(setDrawerRegister(false))}></i>
          {t('注册')}
        </h3>
        <RegisterForm/>
      </div>
    </Drawer>
  );
}

function ForgetPwdDrawer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { drawerForgetPwd } = useSelector(state => state);
  
  return (
    <Drawer visible={drawerForgetPwd}
            onClose={() => dispatch(setDrawerForgetPwd(false))}>
      <div className={'px-[8%] mt-[22%]'}>
        <h3 className={'text-2xl mb-[50px]'}>
          <i className={'iconfont icon-delete text-2xl mr-[20px] cursor-pointer'}
             onClick={() => dispatch(setDrawerForgetPwd(false))}></i>
          {t('忘记密码')}
        </h3>
        <ForgetPwdForm/>
      </div>
    </Drawer>
  );
}

function SearchDrawer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { drawerSearch } = useSelector(state => state);
  const [keyword, setKeyword] = useState('');
  const isMdMax = mediaMatch.isMdmax;
  const navigateTo = useNavigateTo();
  
  const inputHandle = (e) => {
    setKeyword(e.target.value);
  };
  
  const inputKeyUp = (e) => {
    if (e.keyCode === 13) {
      navigateTo(`/searchGoodsPage?keyword=${keyword}`);
      dispatch(setDrawerSearch(false));
    }
  };
  
  return (
    <Drawer style={{ width: '100%', padding: 0, zIndex: 999 }}
            visible={drawerSearch}
            onClose={() => dispatch(setDrawerSearch(false))}
            top={isMdMax}>
      <div className={'m-[28px] relative'}>
        <p className="text-right pb-[30px]">
          <i className="iconfont icon-delete text-[20px] cursor-pointer"
             onClick={() => dispatch(setDrawerSearch(false))}></i>
        </p>
        <div className="relative">
          <input type="text"
                 onChange={inputHandle}
                 onKeyUp={inputKeyUp}
                 className={'border-b-[1px] container text-xl p-[10px]'}
                 placeholder={t('搜索')}/>
          <i className={'iconfont icon-search absolute right-0 top-[50%] text-[#999] text-[18px]'}
             style={{ transform: 'translateY(-50%)' }}/>
        </div>
      </div>
      <div className={"w-[100vw] h-[100vh] md:hidden"}
           onClick={() => dispatch(setDrawerSearch(false))}>
      </div>
    </Drawer>
  );
}

function App() {
  const elements = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const agentInfo = cookies.getAgentInfo();
  
  useEffect(() => {
    if (authPages.includes(location.pathname) && !cookies.getToken()) {
      return navigate('/');
    }
    
    routes.forEach((route) => {
      if (route.path === location.pathname) {
        let routeName = route.name;
        document.title = `${t(route.name)} - ${agentInfo.agentName || ''}`;
        setTimeout(() => {
          ga(location.pathname, routeName);
          console.log('ga send');
        }, 50);
      }
    });
    console.log('???');
  }, [location]);
  
  return (
    <Provider store={store}>
      <Suspense fallback={<></>}>
        {elements}
      </Suspense>
      <SearchDrawer/>
      <WhatsAppButton/>
    </Provider>
  );
}

export default App;
